var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarArrowIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6665 2.50004H14.8332V0.833374H13.1665V2.50004H4.83317V0.833374H3.1665V2.50004H2.33317C1.4165 2.50004 0.666504 3.25004 0.666504 4.16671V17.5C0.666504 18.4167 1.4165 19.1667 2.33317 19.1667H15.6665C16.5832 19.1667 17.3332 18.4167 17.3332 17.5V4.16671C17.3332 3.25004 16.5832 2.50004 15.6665 2.50004ZM15.6665 17.5H2.33317V6.66671H15.6665V17.5Z",
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarArrowIcon);
export default __webpack_public_path__ + "static/media/calendar-arrow-icon.2047cc911430222984d7371947839e79.svg";
export { ForwardRef as ReactComponent };